import React, {forwardRef, useCallback, useEffect, useState} from "react";
import {AutoComplete, Button, ButtonToolbar, Checkbox, DatePicker, Form, Modal} from 'rsuite';
import {deleteUserExperience, updateUserExperience} from "../../../service/experienceService";
import {experienceModel} from "../../form/models";
import {commonJobTitles} from "../../constants/commonJobTitles";

const startDateInstance = forwardRef((props, ref) =>
    <DatePicker {...props} format="yyyy-MM" oneTap ranges={[]} style={{width: 200}} ref={ref}/>
);
const endDateInstance = forwardRef((props, ref) =>
    <DatePicker {...props} format="yyyy-MM" oneTap ranges={[]} style={{width: 200}} ref={ref}/>
);

const EditExperienceModal = (props) => {
    const { open, handleClose, experience, userId } = props;

    const [localState, setLocalState] = useState({userId});

    const localClose = useCallback((response) => {
        handleClose(response);
        setLocalState({});
    }, [handleClose]);

    const submitExperienceEdit = useCallback((isFormValid) => {
        if(!isFormValid) return;
        updateUserExperience(localState).then((response) => {
            localClose(response);
        });
    }, [localClose, localState]);

    const submitExperienceDelete = useCallback(() => {
        deleteUserExperience({id: localState.id, userId: localState.userId}).then((response) => {
            localClose(response);
        });
    }, [localClose, localState]);

    useEffect(() => {
        setLocalState({...experience});
    }, [experience]);

    // rsuite does not have an onSubmit, we must handle state changes per controlled field
    const handleFormChange = (event) => {
        if(event.isPresent === true) {
            event.endDate = new Date();
        }
        setLocalState({...localState, ...event});
    }

    return (
        <Modal
            open={open}
            onClose={localClose}
            backdrop="static"
        >
            <Modal.Header>
                <Modal.Title>Edit Experience</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            </Modal.Body>
            <Form layout="horizontal"
                  model={experienceModel}
                  onChange={handleFormChange}
                  onSubmit={submitExperienceEdit}
                  formDefaultValue={experience}>
                <Form.Group>
                    <Form.ControlLabel>Position</Form.ControlLabel>
                    <Form.Control name="position"
                                  accepter={AutoComplete}
                                  data={commonJobTitles}
                                  style={{width: 300}}
                    />
                </Form.Group>
                <Form.Group>
                    <Form.ControlLabel>Company</Form.ControlLabel>
                    <Form.Control name="company"/>
                </Form.Group>
                <Form.Group>
                    <Form.ControlLabel>Start Date</Form.ControlLabel>
                    <Form.Control name="startDate" accepter={startDateInstance} />
                </Form.Group>
                <Form.Group>
                    <Form.ControlLabel>EndDate</Form.ControlLabel>
                    <Form.Control
                        name="endDate"
                        accepter={endDateInstance}
                        disabled={localState.isPresent}
                        value={localState.endDate}
                    />
                </Form.Group>
                <Form.Group>
                    <Form.ControlLabel>Present</Form.ControlLabel>
                    <Form.Control name="isPresent"
                                  accepter={Checkbox}
                                  checked={localState.isPresent}
                                  value={!localState.isPresent}
                    />
                </Form.Group>
                <Form.Group>
                    <ButtonToolbar>
                        <Button type="submit" appearance="primary">
                            Ok
                        </Button>
                        <Button onClick={localClose} appearance="default">
                            Cancel
                        </Button>
                        <Button onClick={submitExperienceDelete} appearance="primary" color="red">
                            Delete Experience
                        </Button>
                    </ButtonToolbar>
                </Form.Group>
            </Form>
        </Modal>
    );
}

export default EditExperienceModal;